export default __webpack_public_path__ + "static/681-2cb8646ff14b0a018930563f4705562a.gif";